import React, { useCallback, useContext } from "react";
import { URL_DT_EXIT } from "../../../config/urls";
import { H2, Text } from "../../../components/typography";
import { useTranslation } from "react-i18next";
import { Modal } from "../../../components/modal";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import { useNavigator } from "../../../hooks/use-navigator";
import { useAdobeAnalytics } from "../../../hooks/use-adobe-analytics";
import { Context } from "../../../store/store";

interface ExitDrugTestDialogProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ExitDrugTestDialog = ({
  isOpen,
  onClose,
}: ExitDrugTestDialogProps) => {
  const [goToExitDrugTest] = useNavigator(URL_DT_EXIT);
  const { t } = useTranslation();
  const { addCustomEventMetric } = useAdobeAnalytics();
  const { state } = useContext(Context);
  const exitDrugTest = useCallback(() => {
    addCustomEventMetric({ eventName: "exit drug test" });
    state.timerFinished = false;
    goToExitDrugTest();
  }, []);

  return (
    <Modal isOpen={isOpen} close={onClose}>
      <Col gridGap="2rem">
        <H2>{t("dialog-exitDrugTest-title")}</H2>
        <Row>
          <Text>{t("dialog-exitDrugTest-message")}</Text>
        </Row>
        <Row justifyContent="flex-end" gridGap="1rem">
          <Button onClick={onClose}>{t("common-cancel")}</Button>
          <Button onClick={exitDrugTest} variant={ButtonVariant.Primary}>
            {t("common-confirm")}
          </Button>
        </Row>
      </Col>
    </Modal>
  );
};
